import {
  AbilityBuilder
} from '@casl/ability'

export default function defineAbilityFor(user) {
  const {
    rules,
    can,
    cannot
  } = AbilityBuilder.extract()
  //console.log(user || 'roles is empty')
  if (user == 'Admin' || user.includes('Admin')) {
    can('read', 'navigation')
    can('read', 'cutting')
    // can('manage', 'cutting')
  } else if (user == 'Customer' || user.includes('Customer')) {
    can('read', 'navigation')
    can('read', 'cutting')
  } else {
    can('read', 'navigation')
    cannot('read', 'cutting')
  }

  return rules
}